import { OfferPriceInterface } from 'common/types/entities/OfferPriceInterface'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { useOrderTotals } from 'publisher/pages/offer-page/hooks/use-order-totals'
import { usePage, usePayment } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import { setActivePricePlanId } from 'publisher/store/payment/paymentActions'
import {
  getCheckedBump,
  getProduct,
} from 'publisher/store/payment/paymentSelectors'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useCalculatedPricePlans } from 'src/publisher/hooks/use-calculated-price-plans'
import { useFetchOfferPricing } from 'src/publisher/hooks/use-fetch-offer-pricing'
import { useOfferPricing } from 'src/publisher/hooks/use-offer-pricing'
import { OfferPrice as CommonOfferPrice } from 'src/shared/components/offer-price'

export const OfferPrice = ({ entity }: { entity: OfferPriceInterface }) => {
  const dispatch = useDispatch()
  const [isClient, setIsClient] = useState(false)
  const locale = usePage(pageSelectors.getLocale)

  const { pricePlans, activePlanId } = useCalculatedPricePlans()
  const bump = usePayment(getCheckedBump)
  const bumpPlan = bump?.pricePlans[0]
  const product = usePayment(getProduct)
  const productBump = bump?.product || null

  useFetchOfferPricing()

  const {
    physicalMainOfferPricing,
    physicalBumpOfferPricing,
    digitalOfferPricings,
    digitalBumpOfferPricing,
  } = useOfferPricing()

  useEffect(() => {
    setIsClient(true)
  }, [])

  // includes all taxes and shipping fees
  const { dueToday, orderTotal } = useOrderTotals()

  return (
    isClient && (
      <StyleWrapper
        margin={entity.margin}
        appearance={entity.appearance}
        mobileMargin={entity.mobileMargin}
      >
        <CommonOfferPrice
          attrId={entity.htmlAttrId}
          plans={pricePlans}
          activePlanId={activePlanId}
          bumpPlan={bumpPlan}
          mainOfferPricing={physicalMainOfferPricing}
          bumpOfferPricing={physicalBumpOfferPricing}
          pricePlansPricing={digitalOfferPricings}
          bumpPlanPricing={digitalBumpOfferPricing}
          product={product}
          productBump={productBump}
          total={orderTotal}
          dueToday={dueToday}
          togglePricePlan={(pricePlanId: number) =>
            dispatch(setActivePricePlanId(pricePlanId))
          }
          customDescription={entity.customDescription}
          locale={locale}
          offerLineUiProps={{
            nameFontFamily: entity.nameFontFamily,
            mobileNameFontFamily: entity.mobileNameFontFamily,
            nameFontSize: entity.nameFontSize,
            mobileNameFontSize: entity.mobileNameFontSize,
            nameFontStyle: entity.nameFontStyle,
            mobileNameFontStyle: entity.mobileNameFontStyle,
            nameFontWeight: entity.nameFontWeight,
            mobileNameFontWeight: entity.mobileNameFontWeight,
            nameLineHeight: entity.nameLineHeight,
            mobileNameLineHeight: entity.mobileNameLineHeight,
            nameColor: entity.nameColor,
            mobileNameColor: entity.mobileNameColor,
            amountFontFamily: entity.amountFontFamily,
            mobileAmountFontFamily: entity.mobileAmountFontFamily,
            amountFontSize: entity.amountFontSize,
            mobileAmountFontSize: entity.mobileAmountFontSize,
            amountFontStyle: entity.amountFontStyle,
            mobileAmountFontStyle: entity.mobileAmountFontStyle,
            amountFontWeight: entity.amountFontWeight,
            mobileAmountFontWeight: entity.mobileAmountFontWeight,
            amountLineHeight: entity.amountLineHeight,
            mobileAmountLineHeight: entity.mobileAmountLineHeight,
            amountColor: entity.amountColor,
            mobileAmountColor: entity.mobileAmountColor,
            descriptionFontFamily: entity.descriptionFontFamily,
            mobileDescriptionFontFamily: entity.mobileDescriptionFontFamily,
            descriptionFontSize: entity.descriptionFontSize,
            mobileDescriptionFontSize: entity.mobileDescriptionFontSize,
            descriptionFontStyle: entity.descriptionFontStyle,
            mobileDescriptionFontStyle: entity.mobileDescriptionFontStyle,
            descriptionFontWeight: entity.descriptionFontWeight,
            mobileDescriptionFontWeight: entity.mobileDescriptionFontWeight,
            descriptionLineHeight: entity.descriptionLineHeight,
            mobileDescriptionLineHeight: entity.mobileDescriptionLineHeight,
            descriptionColor: entity.descriptionColor,
            mobileDescriptionColor: entity.mobileDescriptionColor,
          }}
        />
      </StyleWrapper>
    )
  )
}
